import { html } from "lit";
import { formatHtml } from "@trumpf/ux.common-storybook";
import { unsafeHTML } from "lit/directives/unsafe-html.js";
import { renderStandardPictureElement } from "../../../utils";
import { authConfig } from "../../../../.storybook/Auth";

export default {
    title: "MyTrumpf/Partial Templates/Detail Header",
    parameters: {
        docs: {
            source: {
                transform: formatHtml,
            },
        },
    },
};

export const DetailHeader = (data) => html`
    <div class="ux-row">
        ${
            data.image
                ? html`
                      <div class="ux-col-12 ux-col-lg-5">
                          <div
                              class="ux-u-d-flex ux-u-flex-dir-column ux-u-flex-jc-between ux-u-mb-xxs ux-u-mb-md-zero"
                          >
                              <div class="ux-u-pos-relative">
                                  ${data.multipleImages && data.authImage
                                      ? html`
                                            <ux-slider
                                                effect="fade"
                                                arrows-follow-img=""
                                                class="ux-u-mb-xxs"
                                            >
                                                <ux-slider-slide label="">
                                                    <uxc-auth-image
                                                        src="https://api-s.trumpf.com/asset-management/1.0/images/asset-types/TRBV85SX/media/images/TB%20V%2085%20S_08_03_RGB.jpg"
                                                        scope="mytrumpf"
                                                    >
                                                        <ux-image
                                                            style="min-height: 150px;"
                                                            alt="${data.headline}"
                                                        ></ux-image>
                                                    </uxc-auth-image>
                                                </ux-slider-slide>
                                                <ux-slider-slide label="">
                                                    <uxc-auth-image
                                                        src="https://api-s.trumpf.com/asset-management/1.0/images/asset-types/TRBV85SX/media/images/TB%20V%2085%20S_08_03_RGB.jpg"
                                                        scope="mytrumpf"
                                                    >
                                                        <ux-image
                                                            style="min-height: 150px;"
                                                            alt="${data.headline}"
                                                        ></ux-image>
                                                    </uxc-auth-image>
                                                </ux-slider-slide>
                                                <ux-slider-pagination
                                                    anchor-pagination=""
                                                    slot="pagination"
                                                ></ux-slider-pagination>
                                            </ux-slider>
                                        `
                                      : data.multipleImages && !data.authImage
                                        ? html`
                                              <ux-slider
                                                  effect="fade"
                                                  arrows-follow-img=""
                                                  class="ux-u-mb-xxs"
                                              >
                                                  <ux-slider-slide label="">
                                                      ${renderStandardPictureElement(
                                                          {
                                                              width: 708,
                                                              height: 472,
                                                          }
                                                      )}
                                                  </ux-slider-slide>
                                                  <ux-slider-slide label="">
                                                      ${renderStandardPictureElement(
                                                          {
                                                              width: 708,
                                                              height: 472,
                                                          }
                                                      )}
                                                  </ux-slider-slide>
                                                  <ux-slider-pagination
                                                      anchor-pagination=""
                                                      slot="pagination"
                                                  ></ux-slider-pagination>
                                              </ux-slider>
                                          `
                                        : !data.multipleImages && data.authImage
                                          ? html`<uxc-auth-image
                                                src="https://api-s.trumpf.com/asset-management/1.0/images/asset-types/TRBV85SX/media/images/TB%20V%2085%20S_08_03_RGB.jpg"
                                                scope="mytrumpf"
                                            >
                                                <ux-image
                                                    style="min-height: 150px;"
                                                    alt="${data.headline}"
                                                ></ux-image>
                                            </uxc-auth-image>`
                                          : renderStandardPictureElement({
                                                width: 708,
                                                height: 472,
                                            })}
                                  <ux-button
                                      size="icon"
                                      icon="pencil-square"
                                      class="ux-u-absolute ux-u-background-white"
                                      title="Edit Image"
                                      style="z-index: 1; right: 10px; top: 10px;"
                                      data-trigger-async-modal="open,mymachine-edit"
                                  >
                                  </ux-button>
                                  ${data.imageInfoButton
                                      ? html` <a
                                            href="#"
                                            class="ux-button ux-button--white ux-button--icon-only ux-u-absolute"
                                            title="Link to Product Page"
                                            style="z-index: 1; right: 10px; ${data.multipleImages
                                                ? "bottom: 35px;"
                                                : "bottom: 15px;"}"
                                        >
                                            <ux-icon name="info"></ux-icon>
                                        </a>`
                                      : ""}
                              </div>
                              ${data.imageButtons &&
                              html` <div class="u-hide-m u-hide-t">
                                  ${data.imageButtons.map(
                                      (element) => html`
                                          <a
                                              href="#"
                                              class="ux-shadow-button ux-shadow-button--icon ux-u-mt-xxxs"
                                              ><ux-icon
                                                  name="${element.icon}"
                                              ></ux-icon
                                              >${element.title}<ux-icon
                                                  class="ux-shadow-button__arrow"
                                                  name="arrow-small-right"
                                          /></a>
                                      `
                                  )}
                              </div>`}
                          </div>
                      </div>
                  `
                : ""
        }
            <div class="ux-col-12 ${data.image ? "ux-col-lg-7" : ""}">
                <div class="ux-info-box">
                    ${
                        data.status
                            ? html`<div
                                  class="ux-info-box__status ux-text-status ux-text-status--${data.statusColor}"
                              >
                                  <ux-icon name="circle-filled"></ux-icon>
                                  ${data.status}
                              </div>`
                            : ""
                    }
                    <div class="ux-u-mb-xxs ux-u-mb-lg-xs">
                        <div class="ux-u-d-flex ux-u-flex-ai-center">
                            <h2 class="ux-text-headline ux-text-headline--big ux-u-my-zero">
                                ${unsafeHTML(data.headline)}
                            </h2>
                            <ux-icon name="pencil-square" size-s="18" class="ux-u-ml-xxxs ux-u-cursor-pointer" data-trigger-async-modal="open,mymachine-edit" role="button"></ux-icon>
                        </div>
          
                        ${
                            data.subline
                                ? html`<div
                                      class="ux-text-normal ux-u-mt-lg-xxxs"
                                  >
                                      ${unsafeHTML(data.subline)}
                                  </div>`
                                : ""
                        }
                    </div>
                    ${
                        data.keyValuePairs
                            ? html`<div class="ux-row">
                                  ${data.keyValuePairs.map(
                                      (element) =>
                                          html`<div
                                              class="${data.image
                                                  ? "ux-col-12 ux-col-md-6 ux-u-mb-xxs"
                                                  : "ux-col-6 ux-col-md-2"}"
                                          >
                                              <div class="ux-u-mb-xxxs">
                                                  <span
                                                      class="ux-info-box__headline ux-text-tiny ux-text-tiny--bold ux-u-text-uppercase"
                                                      >${element.title}</span
                                                  >
                                                  ${element.edit
                                                      ? html`
                                                            <ux-icon
                                                                name="pencil-square"
                                                                size-s="16"
                                                                class="ux-u-ml-xxxs ux-u-cursor-pointer"
                                                                data-trigger-async-modal="open,mymachine-edit"
                                                                role="button"
                                                            ></ux-icon>
                                                        `
                                                      : ""}
                                              </div>
                                              ${element.status
                                                  ? html`<div
                                                        class="ux-text-status ux-text-status--green"
                                                    >
                                                        <ux-icon
                                                            name="circle-filled"
                                                        ></ux-icon>
                                                        ${element.value}
                                                    </div>`
                                                  : html`<div
                                                        class="ux-info-box__text ux-text-normal"
                                                    >
                                                        ${unsafeHTML(
                                                            element.value
                                                        )}
                                                    </div>`}
                                              ${element.detail
                                                  ? html`
                                                        <div
                                                            class="ux-info-box__text ux-text-tiny"
                                                        >
                                                            ${element.detail}
                                                        </div>
                                                    `
                                                  : ""}
                                          </div>`
                                  )}
                              </div>`
                            : ""
                    }
                    ${
                        data.discontinued
                            ? html`<div class="ux-info-box__fact-block">
                                  <div
                                      class="ux-info-box__fact--highlight ux-u-background-grey-table-bg"
                                  >
                                      <div
                                          class="ux-info-box__headline ux-text-tiny"
                                      >
                                          <span
                                              class="ux-text-tiny--bold ux-u-text-uppercase"
                                          >
                                              ${data.discontinued.title}
                                          </span>
                                          <ux-icon
                                              name="info"
                                              class="ux-u-ml-xxxs"
                                          ></ux-icon>
                                          <ux-tooltip
                                              tooltip-target="ux-icon[name='info']"
                                              align="top"
                                          >
                                              <div
                                                  class="ux-u-d-flex ux-u-flex-dir-column ux-u-flex-ai-center"
                                              >
                                                  <span
                                                      class="ux-text-status--${data
                                                          .discontinued.type ===
                                                      "soc"
                                                          ? "dark-blue"
                                                          : "red"}"
                                                  >
                                                      <ux-icon
                                                          name=${data
                                                              .discontinued
                                                              .tooltipIcon}
                                                          size-s="44"
                                                          weight="normal"
                                                      ></ux-icon>
                                                  </span>
                                                  <h6
                                                      class="ux-u-ml-xxxs ux-u-mt-xxxs ux-u-mb-zero ux-text-headline ux-text-headline--small ux-u-text-align--center"
                                                  >
                                                      ${data.discontinued
                                                          .tooltipTitle}
                                                  </h6>
                                              </div>
                                              <p class="ux-text-normal">
                                                  ${unsafeHTML(
                                                      data.discontinued
                                                          .tooltipCopy
                                                  )}
                                              </p>
                                              <a
                                                  href="#"
                                                  class="ux-text-link ux-text-link--green ux-text-normal"
                                                  >Mehr erfahren
                                                  <ux-icon
                                                      name="arrow-small-right"
                                              /></a>
                                          </ux-tooltip>
                                      </div>
                                      <p class="ux-text-normal ux-u-mb-zero">
                                          ${data.discontinued.copy}
                                      </p>
                                  </div>
                              </div>`
                            : ""
                    }
                    ${
                        data.softwareUpdates
                            ? html` <div class="ux-row">
                                  <div class="ux-col-12">
                                      <ux-iws-software-updates
                                          url="mock-data/machine-detail/software-updates-${data.softwareUpdatesType}.json"
                                          url-form-post-api="mock-data/machine-detail/software-updates-form-submit.json"
                                          tooltip-link="#tooltip"
                                          read-more-link="#read-more"
                                          privacy-policy-link="#privacy-policy"
                                          language="de-DE"
                                      >
                                      </ux-iws-software-updates>
                                  </div>
                              </div>`
                            : ""
                    }
                    ${
                        data.comment
                            ? html`<div>
                                  <div
                                      class="ux-info-box__headline ux-text-tiny ux-text-tiny--bold ux-u-text-uppercase"
                                  >
                                      Kommentar
                                  </div>
                                  <p class="ux-info-box__text ux-text-normal">
                                      ${data.comment}
                                  </p>
                              </div>`
                            : ""
                    }
                    ${
                        data.buttons &&
                        html` <div class="ux-row">
                            ${data.buttons.map(
                                (element) => html`
                                    ${element.href &&
                                    html`<div
                                        class="ux-col-12 ux-col-md-6 ux-u-mt-xxs"
                                    >
                                        <a class="ux-button ux-u-w-100">
                                            ${element.title}
                                        </a>
                                    </div>`}
                                    ${element.dataTriggerAsyncModal &&
                                    html`<ux-button
                                        class="ux-col-12 ux-col-md-6 ux-u-mt-xxs"
                                        data-trigger-async-modal=${element.dataTriggerAsyncModal}
                                    >
                                        ${element.title}
                                    </ux-button>`}
                                `
                            )}
                        </div>`
                    }
                </div>
            </div>
        </div>
        ${
            data.imageButtons &&
            html` <div class="u-hide-d u-hide-large">
                ${data.imageButtons.map(
                    (element) => html`
                        <a
                            href="#"
                            class="ux-shadow-button ux-shadow-button--icon ux-u-mt-xxxs"
                            ><ux-icon name="${element.icon}"></ux-icon
                            >${element.title}<ux-icon
                                class="ux-shadow-button__arrow"
                                name="arrow-small-right"
                        /></a>
                    `
                )}
            </div>`
        }
    </div>
`;

const DetailHeaderTemplate = (data) => html`
    ${DetailHeader(data)}
    <ux-iws-async-modal
        name="mymachine-edit"
        src="mock-data/mymachine-edit.html"
    ></ux-iws-async-modal>
    <ux-u-silent-auth
        client-id="${authConfig.clientId}"
        client-name="mytrumpf"
        issuer="https://identity-s.trumpf.com"
        scope="openid"
    >
    </ux-u-silent-auth>
`;

export const MySoftware = DetailHeaderTemplate.bind({});
MySoftware.args = {
    image: true,
    authImage: true,
    multipleImages: true,
    headline: "User machine name",
    keyValuePairs: [
        { title: "Latest delivered version", value: "11.12.0" },
        {
            title: "Latest available version",
            value: "13.16.22",
            detail: "Released on 25.02.22",
        },
        {
            title: "Service Agreement Status",
            value: "Active",
            status: "active",
        },
        { title: "Contract Start", value: "17.01.2022" },
        { title: "Number of licenses", value: "3" },
    ],
};

export const MyMachines = DetailHeaderTemplate.bind({});
MyMachines.args = {
    image: true,
    multipleImages: true,
    authImage: false,
    imageInfoButton: false,
    imageButtons: [
        {
            title: "Zu den Biegewekzeugen",
            icon: "cart-bending-tools",
        },
        {
            title: "Zu den Original Teilen",
            icon: "cart-genuine-parts",
        },
    ],
    status: "Active",
    statusColor: "green",
    headline: "User machine name",
    subline: "TruMaschine 2030",
    keyValuePairs: [
        { title: "Maschinennummer", value: "TWDEDEMO078" },
        {
            title: "Baujahr",
            value: "1999",
        },
        {
            title: "Standort",
            value: "DE-70469",
            edit: true,
        },
        { title: "Gewährleistung", value: "17.01.2022 - 16.01.2023" },
    ],
    softwareUpdates: "AllUpdatesSubscribed",
    discontinued: {
        type: "soc",
        title: "Eingeschränkter Support der Maschine",
        copy: "Ab 31.12.2022",
        tooltipIcon: "cog-crossed",
        tooltipTitle: "Das Produkt wird zum 31.12.2021 abgekündigt.",
        tooltipCopy:
            "Leider kann deshalb nur ein eingeschränkter Support zur Verfügung gestellt werden. Sollten Sie Fragen zur Abkündigung haben, wenden Sie sichgerne an Ihren <a href='#' class='ux-text-link ux-text-link--green'>Service-Ansprechpartner</a> bei TRUMPF.",
    },
    comment:
        "Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam dolores molores.",
    buttons: [
        {
            title: "Request E-Catalog",
            dataTriggerAsyncModal: "open,request-e-catalog-modal",
        },
        {
            title: "Create Service Case",
            dataTriggerAsyncModal: "open,create-service-call-modal",
        },
        {
            title: "Punch Guide",
            href: "#",
        },
    ],
};
